module.exports = __webpack_public_path__ + "img/AyudaCard.e3856c46.png";